import { render, staticRenderFns } from "./Methods.vue?vue&type=template&id=275c7bb6"
import script from "./Methods.vue?vue&type=script&lang=js"
export * from "./Methods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports